import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SuppliersView } from "src/components/views/erp/purchase/suppliers/SuppliersView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/erp/purchase/suppliers")({
	staticData: { title: i18n.t("suppliers"), legacyViewKey: "suppliersPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SuppliersView />;
}
